import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import PermissionRoute from "../components/PermissionRoute";

// Layout Components
import GlobalLayout from "../layouts/GlobalLayout";
import PageView from "../layouts/PageView";

// Page Components
import Login from "../pages/login/Login";
import Dashboard from "../pages/dashboard/Dashboard";

// Analysis Pages

// User Pages
import UserList from "../pages/users/UserList";
import UserDetails from "../pages/users/UserDetails";

// Banner Pages
import BannerList from "../pages/banners/BannerList";
import AddBanner from "../pages/banners/AddBanner";
import EditBanner from "../pages/banners/EditBanner";

// Collections Pages
import CollectionList from "../pages/collections/CollectionList";
import AddCollection from "../pages/collections/AddCollection";
import EditCollection from "../pages/collections/EditCollection";

// Template Pages
import TemplateList from "../pages/templates/TemplateList";
import AddTemplate from "../pages/templates/AddTemplate";
import EditTemplate from "../pages/templates/EditTemplate";

//Pages
import PageList from "../pages/Page/PageList";
import AddPage from "../pages/Page/AddPage";
import EditPage from "../pages/Page/EditPage";

// OnBoarding Pages
import OnBoardingList from "../pages/onboarding/OnBoardingList";
import OnBoardingForm from "../pages/onboarding/OnBoardingForm";

// Category Pages
import CategoryList from "../pages/categories/CategoryList";
import AddCategory from "../pages/categories/AddCategory";
import EditCategory from "../pages/categories/EditCategory";

import CategoryMasterList from "../pages/master/Category/CategoryList";
import AddMasterCategory from "../pages/master/Category/AddCategory";
import EditMasterCategory from "../pages/master/Category/EditCategory";

// Promo Pages
import PromoList from "../pages/promo/PromoList";
import PromoForm from "../pages/promo/PromoForm";
import PromoCampaignList from "../pages/promo_campaign/PromoCampaignList";
import PromoCampaignForm from "../pages/promo_campaign/PromoCampaignForm";

// Master Pages
import CountryList from "../pages/master/Country/CountryList";
import AddCountry from "../pages/master/Country/AddCountry";
import EditCountry from "../pages/master/Country/EditCountry";
import CurrencyList from "../pages/master/Currency/CurrencyList";
import AddCurrency from "../pages/master/Currency/AddCurrency";
import EditCurrency from "../pages/master/Currency/EditCurrency";
import GenreList from "../pages/master/VideoGenre/GenreList";
import AddGenre from "../pages/master/VideoGenre/AddGenre";
import EditGenre from "../pages/master/VideoGenre/EditGenre";
import LanguageList from "../pages/master/VideoLanguages/LanguageList";
import AddLanguage from "../pages/master/VideoLanguages/AddLanguage";
import EditLanguage from "../pages/master/VideoLanguages/EditLanguage";
import AnnouncementList from "../pages/master/Announcement/AnnouncementList";
import AddAnnouncement from "../pages/master/Announcement/AddAnnouncement";
import EditAnnouncement from "../pages/master/Announcement/EditAnnouncement";
import SpotlightList from "../pages/master/Spotlight/SpotlightList";
import AddSpotlight from "../pages/master/Spotlight/AddSpotlight";
import EditSpotlight from "../pages/master/Spotlight/EditSpotlight";
import TagList from "../pages/master/Tag/TagList";
import AddTag from "../pages/master/Tag/AddTag";
import EditTag from "../pages/master/Tag/EditTag";
import ContentTypeList from "../pages/master/ContentType/ContentTypeList";
import AddContentType from "../pages/master/ContentType/AddContentType";
import EditContentType from "../pages/master/ContentType/EditContentType";
import SalesChannelList from "../pages/master/SalesChannel/SalesChannelList";
import AddSalesChannel from "../pages/master/SalesChannel/AddSalesChannel";
import EditSalesChannel from "../pages/master/SalesChannel/EditSalesChannel";
import FaqList from "../pages/master/FAQs/FaqList";
import AddFaq from "../pages/master/FAQs/AddFaq";
import EditFaq from "../pages/master/FAQs/EditFaq";
import PrivacyPolicyList from "../pages/master/PrivacyPolicy/PrivacyPolicyList";
import AddPrivacyPolicy from "../pages/master/PrivacyPolicy/AddPrivacyPolicy";
import EditPrivacyPolicy from "../pages/master/PrivacyPolicy/EditPrivacyPolicy";
import TermsConditionsList from "../pages/master/TermsConditions/TermsConditionsList";
import AddTermsConditions from "../pages/master/TermsConditions/AddTermsConditions";
import EditTermsConditions from "../pages/master/TermsConditions/EditTermsConditions";
import AboutUs from "../pages/master/AboutUs/AboutUs";
import MobileAppStoreList from "../pages/master/MobileAppStore/MobileAppStoreList";
import AddMobileAppStore from "../pages/master/MobileAppStore/AddMobileAppStore";
import EditMobileAppStore from "../pages/master/MobileAppStore/EditMobileAppStore";
import MobileAppBuildConfigList from "../pages/master/MobileAppBuildConfig/MobileAppBuildConfigList";
import AddMobileAppBuildConfig from "../pages/master/MobileAppBuildConfig/AddMobileAppBuildConfig";
import EditMobileAppBuildConfig from "../pages/master/MobileAppBuildConfig/EditMobileAppBuildConfig";
import ContentComplaintsList from "../pages/master/ContentComplaints/ContentComplaintsList";
import AddContentComplaints from "../pages/master/ContentComplaints/AddContentComplaints";
import EditContentComplaints from "../pages/master/ContentComplaints/EditContentComplaints";

// Video Pages
import QualityList from "../pages/video/Quality/QualityList";
import EditQuality from "../pages/video/Quality/EditQuality";
import AddQuality from "../pages/video/Quality/AddQuality";
import RatingList from "../pages/video/Ratings/RatingList";
import EditRating from "../pages/video/Ratings/EditRating";
import AddRating from "../pages/video/Ratings/AddRating";

// Subscription Pages

// Movie Pages
import ShowList from "../pages/video/Show/ShowList";
import OneSignalNotification from "../pages/notification/OneSignalNotification";
import EditShow from "../pages/video/Show/EditShow";
import AddShow from "../pages/video/Show/AddShow";

// TV Show Pages
import TvShowList from "../pages/Tv_show/Show/ShowList";
import EditTvShow from "../pages/Tv_show/Show/EditShow";
import AddTvShow from "../pages/Tv_show/Show/AddShow";

// Payment Pages

// Media Data Pages

// Other Pages

// Settings Pages
import GlobalSettingsList from "../pages/settings/Global_settings/GlobalSettingsList";

// Avatar Pages
import AvatarList from "../pages/master/Avatars/AvatarList";
import AddAvatar from "../pages/master/Avatars/AddAvatar";
import EditAvatar from "../pages/master/Avatars/EditAvatar";

// New Dashboard
import UsersList from "../pages/cms_users/UsersList";
import UsersCreateUpdate from "../pages/cms_users/UsersCreateUpdate";
import RolesCreateUpdate from "../pages/cms_users/RolesCreateUpdate";
import RolesList from "../pages/cms_users/RolesList";
import MenuAccess from "../pages/cms_users/MenuAccess";
import FeatureEdit from "../pages/subscription_v2/features/FeatureEdit";
import FeaturesList from "../pages/subscription_v2/features/FeatureList";
import PlanTypeList from "../pages/subscription_v2/plan_type/PlanTypeList";
import PlanTypeEdit from "../pages/subscription_v2/plan_type/PlanTypeEdit";
import SubPlanList from "../pages/subscription_v2/plans/SubPlanList";
import SubPlanEdit from "../pages/subscription_v2/plans/SubPlanEdit";
import Unauthorized from "../components/Unauthorized";
import SubGenreList from "../pages/master/SubGenre/SubGenreList";
import AddSubGenre from "../pages/master/SubGenre/AddSubGenre";
import EditSubGenre from "../pages/master/SubGenre/EditSubGenre";
import GetAllTalent from "../pages/master/Talent/GetAllTalent";
import EditTalent from "../pages/master/Talent/EditTalent";
import Payment from "../pages/subscription_v2/payment/Payment";
import UserSubscription from "../pages/subscription_v2/user-subscription/UserSubscription";
import AppleInApp from "../pages/subscription_v2/apple-in-app/AppleInApp";
import AppleInAppSubscriptionDetail from "../pages/subscription_v2/apple-in-app/AppleInAppSubscriptionDetail";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Login Route */}
        <Route path="/login" element={<Login />} />

        {/* Main Admin Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <GlobalLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/login" replace />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="website-users" element={<PageView />}>
            <Route
              index
              element={
                <PermissionRoute requiredAction="can_read">
                  <UserList />
                </PermissionRoute>
              }
            />
            <Route
              path="details/:user_id"
              element={
                <PermissionRoute requiredAction="can_read">
                  <UserDetails />
                </PermissionRoute>
              }
            />
          </Route>

          <Route path="cms-users" element={<PageView />}>
            <Route index element={<UsersList />} />
            <Route path="add/:user_id" element={<UsersCreateUpdate />} />
            <Route path="edit/:user_id" element={<UsersCreateUpdate />} />
          </Route>

          <Route path="roles" element={<PageView />}>
            <Route index element={<RolesList />} />
            <Route path="add/:role_id" element={<RolesCreateUpdate />} />
            <Route path="edit/:role_id" element={<RolesCreateUpdate />} />
          </Route>

          <Route path="roles/menu-access/:role_id" element={<MenuAccess />} />

          <Route path="banners" element={<PageView />}>
            <Route index element={<BannerList />} />
            <Route path="add/new" element={<AddBanner />} />
            <Route path="edit/:banner_id" element={<EditBanner />} />
          </Route>

          <Route path="collections" element={<PageView />}>
            <Route index element={<CollectionList />} />
            <Route path="add/new" element={<AddCollection />} />
            <Route path="edit/:id" element={<EditCollection />} />
          </Route>

          <Route path="templates" element={<PageView />}>
            <Route index element={<TemplateList />} />
            <Route path="add/new" element={<AddTemplate />} />
            <Route path="edit/:id" element={<EditTemplate />} />
          </Route>

          <Route path="pages" element={<PageView />}>
            <Route index element={<PageList />} />
            <Route path="add/new" element={<AddPage />} />
            <Route path="edit/:page_id" element={<EditPage />} />
          </Route>

          <Route path="onboarding" element={<PageView />}>
            <Route index element={<OnBoardingList />} />
            <Route path="add/new" element={<OnBoardingForm />} />
            <Route path="edit/:mob_id" element={<OnBoardingForm />} />
          </Route>

          <Route path="promo" element={<PageView />}>
            <Route index element={<PromoList />} />
            <Route path="add/new" element={<PromoForm />} />
            <Route path="edit/:promo_id" element={<PromoForm />} />
          </Route>

          <Route path="promo-campaign" element={<PageView />}>
            <Route index element={<PromoCampaignList />} />
            <Route path="add/new" element={<PromoCampaignForm />} />
            <Route path="edit/:pc_id" element={<PromoCampaignForm />} />
          </Route>


          <Route path="avatar" element={<PageView />}>
            <Route index element={<AvatarList />} />
            <Route path="add/new" element={<AddAvatar />} />
            <Route path="edit/:avatar_id" element={<EditAvatar />} />
          </Route>

          <Route path="countries" element={<PageView />}>
            <Route index element={<CountryList />} />
            <Route path="add/new" element={<AddCountry />} />
            <Route path="edit/:country_id" element={<EditCountry />} />
          </Route>

          <Route path="currencies" element={<PageView />}>
            <Route index element={<CurrencyList />} />
            <Route path="add/new" element={<AddCurrency />} />
            <Route path="edit/:curr_id" element={<EditCurrency />} />
          </Route>

          <Route path="genres" element={<PageView />}>
            <Route index element={<GenreList />} />
            <Route path="add/new" element={<AddGenre />} />
            <Route path="edit/:genre_id" element={<EditGenre />} />
          </Route>

          <Route path="sub-genres" element={<PageView />}>
            <Route index element={<SubGenreList />} />
            <Route path="add/new" element={<AddSubGenre />} />
            <Route path="edit/:genre_id" element={<EditSubGenre />} />
          </Route>

          <Route path="categories" element={<PageView />}>
            <Route index element={<CategoryMasterList />} />
            <Route path="add/new" element={<AddMasterCategory />} />
            <Route path="edit/:category_id" element={<EditMasterCategory />} />
            <Route path="category" element={<CategoryList />} />
            <Route path="category/add" element={<AddCategory />} />
            <Route path="category/edit/:category_id" element={<EditCategory />} />
          </Route>



          <Route path="languages" element={<PageView />}>
            <Route index element={<LanguageList />} />
            <Route path="add/new" element={<AddLanguage />} />
            <Route path="edit/:lang_id" element={<EditLanguage />} />
          </Route>

          <Route path="tags" element={<PageView />}>
            <Route index element={<TagList />} />
            <Route path="add/new" element={<AddTag />} />
            <Route path="edit/:tag_id" element={<EditTag />} />
          </Route>

          <Route path="announcements" element={<PageView />}>
            <Route index element={<AnnouncementList />} />
            <Route path="add/new" element={<AddAnnouncement />} />
            <Route path="edit/:announcement_id" element={<EditAnnouncement />} />
          </Route>

          <Route path="spotlights" element={<PageView />}>
            <Route index element={<SpotlightList />} />
            <Route path="add/new" element={<AddSpotlight />} />
            <Route path="edit/:spotlight_id" element={<EditSpotlight />} />
          </Route>

          <Route path="content-types" element={<PageView />}>
            <Route index element={<ContentTypeList />} />
            <Route path="add/new" element={<AddContentType />} />
            <Route path="edit/:ct_id" element={<EditContentType />} />
          </Route>

          <Route path="sales-channel" element={<PageView />}>
            <Route index element={<SalesChannelList />} />
            <Route path="add/new" element={<AddSalesChannel />} />
            <Route path="edit/:sc_id" element={<EditSalesChannel />} />
          </Route>

          <Route path="faqs" element={<PageView />}>
            <Route index element={<FaqList />} />
            <Route path="add/new" element={<AddFaq />} />
            <Route path="edit/:faq_id" element={<EditFaq />} />
          </Route>

          <Route path="privacy-policy" element={<PageView />}>
            <Route index element={<PrivacyPolicyList />} />
            <Route path="add/new" element={<AddPrivacyPolicy />} />
            <Route path="edit/:pp_id" element={<EditPrivacyPolicy />} />
          </Route>

          <Route path="terms-conditions" element={<PageView />}>
            <Route index element={<TermsConditionsList />} />
            <Route path="add/new" element={<AddTermsConditions />} />
            <Route path="edit/:tc_id" element={<EditTermsConditions />} />
          </Route>

          <Route path="about-us" element={<AboutUs />} />

          <Route path="mobile-app-store" element={<PageView />}>
            <Route index element={<MobileAppStoreList />} />
            <Route path="add/new" element={<AddMobileAppStore />} />
            <Route path="edit/:store_id" element={<EditMobileAppStore />} />
          </Route>

          <Route path="mobile-app-build-config" element={<PageView />}>
            <Route index element={<MobileAppBuildConfigList />} />
            <Route path="add/new" element={<AddMobileAppBuildConfig />} />
            <Route
              path="edit/:build_config_id"
              element={<EditMobileAppBuildConfig />}
            />
          </Route>

          <Route path="content-compliance" element={<PageView />}>
            <Route index element={<ContentComplaintsList />} />
            <Route path="add/new" element={<AddContentComplaints />} />
            <Route
              path="edit/:content_id"
              element={<EditContentComplaints />}
            />
          </Route>

          <Route path="video-quality" element={<PageView />}>
            <Route index element={<QualityList />} />
            <Route path="add/new" element={<AddQuality />} />
            <Route path="edit/:vq_id" element={<EditQuality />} />
          </Route>

          <Route path="ratings" element={<PageView />}>
            <Route index element={<RatingList />} />
            <Route path="add/new" element={<AddRating />} />
            <Route path="edit/:vr_id" element={<EditRating />} />
          </Route>

          <Route path="movies" element={<PageView />}>
            <Route index element={<ShowList />} />
            <Route path="add/new" element={<AddShow />} />
            <Route path="edit/:video_show_id" element={<EditShow />} />
          </Route>
          <Route path="notification" element={<PageView />}>
            <Route index element={<OneSignalNotification />} />
          </Route>

          <Route path="series" element={<PageView />}>
            <Route index element={<TvShowList />} />
            <Route path="add/new" element={<AddTvShow />} />
            <Route path="edit/:tv_show_id" element={<EditTvShow />} />
          </Route>

          <Route path="global-settings" element={<PageView />}>
            <Route index element={<GlobalSettingsList />} />
            {/* <Route path="add/new" element={<AddGlobalSettings />} />
            <Route path="edit/:global_settings_id" element={<EditGlobalSettings />} /> */}
          </Route>

          {/* <Route path="private-settings" element={<PageView />}>
            <Route index element={<PrivateSettingsList />} />
            <Route path="add/new" element={<AddPrivateSettings />} />
            <Route path="edit/:private_gls_id" element={<EditPrivateSettings />} /> 
          </Route> */}

          <Route path="/plans" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><SubPlanList /></PermissionRoute>} />
            <Route path="edit/:plan_id" element={<PermissionRoute requiredAction="can_update"><SubPlanEdit /></PermissionRoute>} />
            <Route path="add/:plan_id" element={<PermissionRoute requiredAction="can_create"><SubPlanEdit /></PermissionRoute>} />
          </Route>

          <Route path="/features" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><FeaturesList /></PermissionRoute>} />
            <Route path="edit/:feature_id" element={<PermissionRoute requiredAction="can_update"><FeatureEdit /></PermissionRoute>} />
            <Route path="add/:feature_id" element={<PermissionRoute requiredAction="can_create"><FeatureEdit /></PermissionRoute>} />
          </Route>

          <Route path="/plan-types" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><PlanTypeList /></PermissionRoute>} />
            <Route path="edit/:plan_type_id" element={<PermissionRoute requiredAction="can_update"><PlanTypeEdit /></PermissionRoute>} />
            <Route path="add/:plan_type_id" element={<PermissionRoute requiredAction="can_create"><PlanTypeEdit /></PermissionRoute>} />
          </Route>
          <Route path="/payment-records" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><Payment /></PermissionRoute>} />
          </Route>
          <Route path="/user-subscriptions" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><UserSubscription /></PermissionRoute>} />
          </Route>
          <Route path="/apple-in-app" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><AppleInApp /></PermissionRoute>} />
            <Route path="subscription/:id" element={<PermissionRoute requiredAction="can_read"><AppleInAppSubscriptionDetail /></PermissionRoute>} />
          </Route>
          <Route path="/plan-types" element={<PageView />}>
            <Route index element={<PermissionRoute requiredAction="can_read"><PlanTypeList /></PermissionRoute>} />
            <Route path="edit/:plan_type_id" element={<PermissionRoute requiredAction="can_update"><PlanTypeEdit /></PermissionRoute>} />
            <Route path="add/:plan_type_id" element={<PermissionRoute requiredAction="can_create"><PlanTypeEdit /></PermissionRoute>} />
          </Route>

          <Route path="talent" element={<PageView />}>
            <Route index element={<GetAllTalent />} />
            <Route path="add/:talent_id" element={<EditTalent />} />
            <Route path="edit/:talent_id" element={<EditTalent />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
